import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { CheckoutToolStepTrackingInfo } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import { Config } from "@/utils/config.utils";

interface AidenProductImpression {
    aidenProductId: string;
    price: number;
    quantity?: number;
}

const getAidenCheckoutTracker = (): Array<any> => {
    window._aiden = window._aiden || [];
    return window._aiden;
};

const processAidenOrderConfirmation = (
    data: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo>
): void => {
    if (
        data.payload?.eventData?.name === "checkout" &&
        data.payload?.eventData?.stepName === "order confirmation"
    ) {
        const products: AidenProductImpression[] = (
            data.payload?.eventData?.cart?.items || []
        ).map((item) => {
            return {
                aidenProductId: item.id,
                price: item.unitPrice,
                quantity: item.quantity
            };
        });

        const tracker = getAidenCheckoutTracker();
        tracker.push({
            event: "Purchase",
            apiKey: Config.integrations["aiden-key"],
            orderId: data.payload?.eventData?.cart?.orderId,
            currency: "EUR",
            products
        });

        return;
    }
};

export { processAidenOrderConfirmation };
